import UpdateCategoryPhoto from "./UpdateCategoryPhoto";

export default UpdateCategoryPhoto;
